/*
 * @Author: huguantao1@jd.com
 * @Date: 2025-02-10 15:18:06
 * @LastEditors: huguantao1@jd.com
 * @LastEditTime: 2025-02-19 15:56:18
 * @FilePath: /intl-m-jdi-website-ssr/src/components/headerFooter/header/components/downloadBar.tsx
 * @Description: default
 */
import CloseThinSVG from '@/assets/icons/closeThin.svg';
import joybuyLogo from '@/assets/icons/joybuyBigLogo.png';
import { useTranslation } from '@/i18n/client';
import { observer } from 'mobx-react';
import Image from 'next/image';
import styles from './downloadBar.module.scss';
import DownloadModule from './downloadModule';
interface IDownloadTip {
  isHideDownloadBar?: boolean;
  setIsHideDownloadBar?: any;
  pageCode?: string;
}

const DownloadBar: React.FC<IDownloadTip> = observer(
  ({ isHideDownloadBar, setIsHideDownloadBar, pageCode }) => {
    const { t } = useTranslation();
    return (
      !isHideDownloadBar && (
        <div className={styles.downloadApp}>
          <button
            className={styles.closeBtn}
            aria-label='close download bar'
            onClick={() => {
              setIsHideDownloadBar(true);
            }}
          >
            <CloseThinSVG />
          </button>
          <div>
            <Image width={48} height={48} src={joybuyLogo} alt='joybuy' />
          </div>
          <div className={styles.txt}>
            <div className={styles.title}>{`Don't just buy, Joybuy`}</div>
            <div className={styles.text}>{t('header.getTheApp')}</div>
          </div>
          <DownloadModule pageCode={pageCode} />
        </div>
      )
    );
  },
);

export default DownloadBar;
